import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { CreateAutomationPage } from "@/modules/automation";
import { requireAuthAndPermission } from "@/utils";

export const Route = createFileRoute("/products/automation/create")({
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Add Automation Product"
        description="Configure automated provisioning for a product on the LAMPU Marketplace."
      />
      <CreateAutomationPage />
    </>
  )
});
